/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsBaseForGcpServiceAccountProtocol extends models.ServiceAccountCredentialsBaseForGcp {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsBaseForGcpServiceAccountProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsBaseForGcpServiceAccountProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsBaseForGcpServiceAccountProtocol>): ServiceAccountCredentialsBaseForGcpServiceAccountProtocol {
        let obj = Object.assign(new ServiceAccountCredentialsBaseForGcpServiceAccountProtocol(), model);
        ServiceAccountCredentialsBaseForGcpServiceAccountProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsBaseForGcpServiceAccountProtocol>): ServiceAccountCredentialsBaseForGcpServiceAccountProtocol {
        if (!model) return null;
        return ServiceAccountCredentialsBaseForGcpServiceAccountProtocol.newInstance(<ServiceAccountCredentialsBaseForGcpServiceAccountProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsBaseForGcpServiceAccountProtocol) {
        if (!obj) return;

        models.ServiceAccountCredentialsBaseForGcpServiceAccountProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsBaseForGcpServiceAccountProtocol): boolean {
        if (models.ServiceAccountCredentialsBaseForGcp.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsBaseForGcpServiceAccountProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Client Email.  This is a required field.
     */
    client_email: string;

    /**
     * Client Id. This is a required field.
     */
    client_id: string;

    /**
     * Private Key. This is a required field.
     */
    private_key: string;

    /**
     * Private Key Id. This is a required field.
     */
    private_key_id: string;

}
